/**
 * Route d'accueil de chaque agent conversationnel monté dans la sandbox, par `agent_type` RBAC.
 * Doit rester alignée sur les routes de `router.ts` portant `meta.agent` (vérifié par `agentRoutes.test.ts`).
 */
export const AGENT_HOME_ROUTES: Readonly<Record<string, string>> = {
  consulting_ggvie: '/ggvie',
  lead: '/vue/chat',
  consulting: '/vue/consulting',
  sapiendo_per: '/sapiendo/per',
}

/** Route d'accueil de l'agent, ou `null` si l'agent n'a pas de vue dans la sandbox. */
export function agentHomeRoute(agent: string): string | null {
  return Object.hasOwn(AGENT_HOME_ROUTES, agent) ? AGENT_HOME_ROUTES[agent] : null
}
